/*
 * Created by alex@hackerbay.com on 21.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../components/Header";
import TextBody from "../components/TextBody";
import Button from "@material-ui/core/es/Button/Button";
import {Container, Row, Col} from "reactstrap";
import i18n from "i18next";
import genesys from "../api/genesys";

import loadingGif from "../media/icons/loading.gif";

import vodafoneLogo from "../media/icons/vf-logo.png";
import {BrowserView,MobileView,isMobile} from "react-device-detect";

class LoadingPage extends React.Component {


    constructor(props){
        super(props);
    }

    render() {
        const loadingImage = <img src={loadingGif} className={"img-fluid"} alt={"vodafone loading animation"} />;

        return <Container style={{height:"100%"}}>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"} />
                    </Col>
                </Row>
                <Row style={{height:"60vh"}}>
                    <center style={{width:"100%"}}>
                        <Col xs={6} style={{marginTop:"40%"}}>
                            {loadingImage}
                        </Col>
                    </center>
                </Row>
            </MobileView>
            <BrowserView>

                <Row style={{height:"80vh"}}>
                    <center style={{width:"100%"}}>
                        <Col xs={6} style={{marginTop:"25%"}}>
                            {loadingImage}
                        </Col>
                    </center>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(LoadingPage);